import "./ui/styles.css";
import { App } from "./ui/app";

const appEl = document.getElementById("app");
const statusEl = document.getElementById("status");
if (appEl && statusEl) {
  new App(appEl, statusEl).start();
}

// Build stamp in the footer: "v1.0.0 · a1b2c3d", with the build date on hover.
const versionEl = document.getElementById("version");
if (versionEl) {
  versionEl.textContent = `v${__APP_VERSION__} · ${__GIT_SHA__}`;
  versionEl.title = `Build ${__BUILD_DATE__}`;
}
